import { mainConstants } from '../constants';
import {localStorageKeysConstants, KYCModalModeTypes} from '../../constants';

const {COMPANY} = KYCModalModeTypes;

const defaultStateProps = {
  availableModules: {loaded: false, modules: []},
  navigationMenuProps: {items: []}
}

const mainState = {
  ...defaultStateProps,
  breadcrumbs: [],
  categories: [],
  currencies: [],
  displayWalletDetailsInitially: false,
  initialLoading: !!localStorage.getItem(localStorageKeysConstants.TOKEN),
  isOpenMenu: localStorage.getItem(localStorageKeysConstants.NAVIGATION_COLLAPSED) !== 'true',
  kycWindowProps: {closeIcon: true, open: false, mode: COMPANY},
  lightKycWindowProps: {open: false},
  isFullWidthAgentChatOpen: false,
  pendingFullWidthAgentChatMessage: null,
  pendingFullWidthAgentChatAttachments: null,
  pendingFullWidthAgentChatReportId: null,
  pendingFullWidthAgentChatResumeSessionId: null,
  hasFullWidthAgentChatStarted: false,
  loading: false,
  navigationLoading: true,
  permissionMatrix: null,
}

const mainReducer = (state = mainState, action) => {
  const {type, data, loading} = action;
  switch (type) {
    case mainConstants.SET_LOADING:
      return {
        ...state,
        loading
      }
    case mainConstants.SET_INITIAL_LOADING:
      return {
        ...state,
        initialLoading: loading
      }
    case mainConstants.SET_NAVIGATION_LOADING:
      return {
        ...state,
        navigationLoading: loading
      }
    case mainConstants.GET_CATEGORIES:
      return {
        ...state,
        categories: data
      }
    case mainConstants.GET_CURRENCIES:
      return {
        ...state,
        currencies: data
      }
    case mainConstants.GET_PERMISSION_MATRIX:
      return {
        ...state,
        permissionMatrix: data
      }
    case mainConstants.COLLAPSE_NAVIGATION_MENU:
      return {
        ...state,
        isOpenMenu: !state.isOpenMenu
      }
    case mainConstants.OPEN_KYC_WINDOW:
      return {
        ...state,
        kycWindowProps: {
          closeIcon: data.closeIcon || true,
          mode: data.mode || COMPANY,
          open: true
        }
      }
    case mainConstants.CLOSE_KYC_WINDOW:
      return {
        ...state,
        kycWindowProps: {...state.kycWindowProps, open: false}
      }
    case mainConstants.DISPLAY_WALLET_DETAILS_INITIALLY:
      return {
        ...state,
        displayWalletDetailsInitially: true
      }
    case mainConstants.OPEN_LIGHT_KYC_WINDOW:
      return {
        ...state,
        lightKycWindowProps: {...state.lightKycWindowProps, open: true}
      }
    case mainConstants.CLOSE_LIGHT_KYC_WINDOW:
      return {
        ...state,
        lightKycWindowProps: {...state.lightKycWindowProps, open: false}
      }
    case mainConstants.OPEN_FULL_WIDTH_AGENT_CHAT:
      return {
        ...state,
        isFullWidthAgentChatOpen: true,
        pendingFullWidthAgentChatMessage: data?.message ?? null,
        pendingFullWidthAgentChatAttachments: data?.attachments ?? null,
        pendingFullWidthAgentChatReportId: data?.reportId ?? null,
        pendingFullWidthAgentChatResumeSessionId: data?.resumeSessionId ?? null
      }
    case mainConstants.RESET_FULL_WIDTH_AGENT_CHAT:
      return {
        ...state,
        pendingFullWidthAgentChatMessage: null,
        pendingFullWidthAgentChatAttachments: null,
        pendingFullWidthAgentChatReportId: null,
        pendingFullWidthAgentChatResumeSessionId: null,
        hasFullWidthAgentChatStarted: false
      }
    case mainConstants.CLOSE_FULL_WIDTH_AGENT_CHAT:
      return {
        ...state,
        isFullWidthAgentChatOpen: false
      }
    case mainConstants.MARK_FULL_WIDTH_AGENT_CHAT_STARTED:
      return {
        ...state,
        hasFullWidthAgentChatStarted: true
      }
    case mainConstants.CLEAR_FULL_WIDTH_AGENT_CHAT_PENDING_MESSAGE:
      return {
        ...state,
        pendingFullWidthAgentChatMessage: null,
        pendingFullWidthAgentChatAttachments: null,
        pendingFullWidthAgentChatReportId: null,
        pendingFullWidthAgentChatResumeSessionId: null
      }
    case mainConstants.CLEAR_MAIN_DATA:
      return {
        ...state,
        availableModules: defaultStateProps.availableModules,
        navigationLoading: true,
        navigationMenuProps: defaultStateProps.navigationMenuProps,
        pendingFullWidthAgentChatMessage: null,
        pendingFullWidthAgentChatAttachments: null,
        pendingFullWidthAgentChatReportId: null,
        pendingFullWidthAgentChatResumeSessionId: null,
        hasFullWidthAgentChatStarted: false
      }
    // Fetched once per login by SystemDataPreloader and scoped to the company, so a switch has to
    // empty them (consumers already handle the initial [] / null) and the preloader refetches.
    case mainConstants.CLEAR_COMPANY_SYSTEM_DATA:
      return {
        ...state,
        categories: mainState.categories,
        permissionMatrix: mainState.permissionMatrix
      }
    case mainConstants.SET_AVAILABLE_MODULES:
      return {
        ...state,
        availableModules: {loaded: true, modules: data.modules}
      }
    case mainConstants.SET_NAVIGATION_MENU_PROPS:
      return {
        ...state,
        navigationMenuProps: action.navigationMenuProps
      }
    case mainConstants.SET_BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: data
      }
    case mainConstants.CLEAR_BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: []
      }
    default:
      return state
  }
};

export default mainReducer;
